<template>
  <div id="evex">
 
    <!-- ======================== 히어로 캐러셀 ======================== -->
    <div id="carousel-evex" class="carousel slide front" data-ride="carousel">
      <div class="carousel-indicators">
        <button type="button" data-bs-target="#carousel-evex" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
        <button type="button" data-bs-target="#carousel-evex" data-bs-slide-to="1" aria-label="Slide 2"></button>
        <button type="button" data-bs-target="#carousel-evex" data-bs-slide-to="2" aria-label="Slide 3"></button>
      </div>
      <div class="carousel-inner">
        <!-- 슬라이드 아이템 (기존 주석 그대로 유지) -->
      </div>
      <button class="carousel-control-prev" type="button" data-bs-target="#carousel-evex" data-bs-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Previous</span>
      </button>
      <button class="carousel-control-next" type="button" data-bs-target="#carousel-evex" data-bs-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Next</span>
      </button>
    </div>
 
    <!-- ======================== 브랜드 소개 ======================== -->
    <section class="evex-container">
      <div class="container">
        <div class="brand-wrap">
          <div class="brand-logo-area">
            <img src="../assets/img/Variety.png" class="brand-logo" />
          </div>
          <div class="brand-text-area">
            <div class="brand-accent-line"></div>
            <p class="brand-desc">
              일반적인 패키지 여행이 아닌 시즌별, 기간별 한정 이벤트여행,<br class="d-none d-md-block">
              기획여행, 테마여행 상품 브랜드 입니다.
            </p>
            <div class="brand-tags">
              <span class="brand-tag"># 시즌 한정</span>
              <span class="brand-tag"># 기획 여행</span>
              <span class="brand-tag"># 테마 여행</span>
            </div>
          </div>
        </div>
      </div>
    </section>
 
    <!-- ======================== 상품 리스트 ======================== -->
    <section class="evex-section">
      <div class="container">
        <div class="col-12" :key="i" v-for="(product, i) in this.productListForSales">
          <div class="evex-item-wrap">
 
            <div class="evexitem">
              <div class="row col-12 mb-0 g-0">
 
                <!-- 이미지 -->
                <div class="col-lg-7 pic"
                     @click="goToDetail(product.pdtCode, product.salesRoute)"
                     style="cursor: pointer">
                  <div class="img-overlay">
                    <span class="img-hover-label">자세히 보기 <i class="bi bi-arrow-right"></i></span>
                  </div>
                  <img v-if="product.imgName != 'noImage'"
                       :src="`/download/${product.pdtCode}/${product.imgName}`"
                       class="card-img-top" alt="..." />
                  <img v-else
                       :src="`/download/noImage/noImage.jpg`"
                       class="card-img-top" />
 
                  <div class="badge">
                    <div v-if="product.badgeFlag === 'Y'">
                      <div class="badge1"><small class="badge1-text">{{ product.badge }}</small></div>
                    </div>
                    <div v-if="product.badge2Flag === 'Y'">
                      <div v-if="product.badgeFlag != 'Y'" class="badge1">
                        <small class="badge1-text">{{ product.badge2 }}</small>
                      </div>
                      <div v-else class="badge2" style="margin-left: 180px;">
                        <small class="badge2-text">{{ product.badge2 }}</small>
                      </div>
                    </div>
                    <div v-else></div>
                  </div>
 
                  <!-- 넘버링 -->
                  <div class="item-number">{{ String(i + 1).padStart(2, '0') }}</div>
                </div>
 
                <!-- 내용 -->
                <div class="col-lg-5 einfo align-self-center">
                  <div class="text mt-2">
 
                    <!-- 출발 태그 -->
                    <div class="departure-tag">
                      <span v-if="product.trCd1 == 'FLT'">
                        <i class="bi bi-airplane-fill"></i> {{ product.cityName }}출발 항공
                      </span>
                      <span v-else-if="product.trCd1 == 'SHP'">
                        <i class="bi bi-tsunami"></i> {{ product.cityName }}출발 선박
                      </span>
                      <span v-else-if="product.trCd1 == 'BUS'">
                        <i class="bi bi-bus-front-fill"></i> 현지출발
                      </span>
                    </div>
 
                    <!-- 상품명 -->
                    <h4 class="title">{{ product.pdtNameKor }}</h4>
 
                    <!-- 설명 -->
                    <p class="binfo">{{ product.pdtRemarks }}</p>
 
                    <!-- 가격 -->
                    <div class="price-area">
                      <div class="text-wrap">
                        <div>
                          <!-- 가격 표시 -->
                          <div class="my-1 d-flex align-items-center flex-wrap price-row"
                               v-if="product.basic_PdtPrice > 0 && product.displayFlag == 'Y' && product.saleFlag == 'Y'"
                               @click="goToDetail(product.pdtCode, product.salesRoute)"
                               style="cursor: pointer;">
                            <b class="fs-3 fw-bolder ndayPrice" v-if="product.discountPercent == 0">
                              {{ getCurrencyFormat(product.pdtPrice) }}<span class="price-won">원</span>
                            </b>
                            <template v-else>
                              <b class="text-muted text-decoration-line-through me-2 original-price">
                                {{ getCurrencyFormat(product.pdtPrice) }}원
                              </b>
                              <i class="bi bi-caret-right-fill text-muted" style="font-size:.8rem"></i>
                              <span class="mx-2 discount-rate">
                                {{ getCurrencyFormat(product.discountPercent) }}%
                              </span>
                              <span class="ndayPrice fs-3 fw-bolder final-price">
                                {{ getCurrencyFormat((product.basic_PdtPrice * 1) + (product.minOptPrice * 1)) }}
                              </span>
                              <span class="price-won fs-5"> 원~</span>
                            </template>
                          </div>
 
                          <!-- 준비중 -->
                          <div class="my-1 d-flex align-items-center preparing-wrap" v-else>
                            <img src="../assets/img/gBus.png" alt="" class="mbus-icon" />
                            <span class="ndayPrice fs-5 fw-bold mx-2 preparing-text">상품을 준비 중입니다</span>
                            <i class="bi bi-question-circle-fill text-danger"
                               style="cursor: pointer; padding-left: 5px;"
                               data-bs-toggle="tooltip" data-bs-placement="top"
                               title="해당상품에 대한 문의가 필요하신 경우 클릭해주세요"
                               @click="inquiryProduct(product.pdtCode, product.salesRoute)"></i>
                          </div>
                        </div>
                      </div>
                    </div>
 
                    <!-- 상세보기 버튼 -->
                    <div class="emore">
                      <div class="detail-btn"
                           @click="goToDetail(product.pdtCode, product.salesRoute)"
                           style="cursor: pointer">
                        <span>상세보기</span>
                        <i class="bi bi-arrow-right ms-2"></i>
                      </div>
                    </div>
 
                  </div>
                </div>
              </div>
            </div>
 
          </div>
        </div>
      </div>
    </section>
 
  </div>
</template>

<script>
export default {
  data() {
    return {
      pdtCatList: [], //상품카테고리
      productListForSales: [], //판매용 상품리스트
    };
  },
  created() {
    // 페이지생성과 동시에 리스트정보를 get
    //this.getNationList();
    this.getPdtCatList();
    this.getProductList_new();
  },
  mounted() {
    // if(document.referrer == "") {
    //   this.$swal.fire('', '적절하지 않은 페이지 접근입니다.', 'error');
    //   //this.$router.push({path: '/'});
    //   location.replace("/");
    // }

    if (this.$store.state.user.handlerId != undefined) {
      document.querySelector(".b2cTag").style.display = "none";
    }
    if (this.$store.state.user.email != undefined) {
      document.querySelector(".b2bTag").style.display = "none";
    }
    // if(this.$store.state.user.buyerId == undefined && this.$store.state.user.email == undefined) {
    //   // document.querySelector(".b2bTag").style.display="none";
    // }
  },
  computed: {
    user() {
      // 리턴정보가 바뀔 때마다 user()안에 넣어준다
      // 로그인전: bId정보없음, 로그인후: bId정보있음
      return this.$store.state.user;
    }
  },  
  methods: {
    async getPdtCatList() 
    {
      let pdtCatList = await this.$api("/api/pdtCatList", {});
      this.pdtCatList = pdtCatList;
    },

    // 신가격정책이 적용된 상품리스트
    async getProductList_new() 
    {
      // 전체로컬상품추출 후, 연계상품제외
      // let productListForSales_tmptmp = await this.$api("/api/productListForSales", {param: ['%', sRoute]});

      // asso가 아닌 vrFlag가 Y인 상품만 추출(버라이어티팩 상품)
      let productListForSales_tmptmp = await this.$api("/api/productPrcInfo_m_new", {});
      
      let productListForSales_tmp = productListForSales_tmptmp.filter((item) => {
        return (item.vrFlag === "Y")
      })
      
      if(productListForSales_tmp.length > 0) 
      {
        // this.productListForSales_org = productListForSales_tmp    //로컬전체상품(org)
        this.productListForSales = productListForSales_tmp;        
      }
      
      //console.log("productListForSales_org: ", this.productListForSales_org)
      //console.log("productListForSales: ", this.productListForSales )
    },

    // 상품문의
    inquiryProduct(pCode, sRoute) {
      this.$router.push({path: '/inquiryProduct', query: {productId: pCode, salesRoute:sRoute}});
    },    

    // mixins에 있는 공통함수 호출샘플
    getCurrencyFormat(value) {
      return this.$currencyFormat(value);
    },
    goToDetail(productId, salesRoute) {
      this.$router.push({path: '/detail', query: {productId: productId, salesRoute:salesRoute}});
    },
  }
};
</script>

<style scoped>
/* ================================================
  # CSS 변수 — #evex 하위 전체 상속, 타 페이지 영향 없음
================================================ */
#evex {
  --ci-green:       #86cd53;
  --ci-green-dark:  #6ab53e;
  --ci-green-light: #e8f7dc;
  --charcoal:       #1c1c1c;
  --charcoal-soft:  #2a2a2a;
  --off-white:      #f9faf7;
  --gray-100:       #f4f5f2;
  --gray-200:       #e5e7e2;
  --gray-400:       #9ea89a;
  --gray-600:       #5a635a;
  --text-main:      #1c1c1c;
  --text-sub:       #5a635a;
  --radius-sm:      6px;
  --radius-md:      14px;
  --shadow-sm:      0 2px 10px rgba(28,28,28,0.07);
  --shadow-md:      0 10px 36px rgba(28,28,28,0.13);
 
  background-color: var(--off-white);
}
 
@media (min-width: 991px) {
  #evex { margin-top: -6rem; }
}
 
 
/* ================================================
  # 캐러셀
================================================ */
#evex .carousel-indicators .active { width: 50px; }
#evex .carousel-item .exmain {
  min-height: 500px;
  max-height: 1000px;
  object-fit: cover;
}
#evex .soldout { filter: brightness(50%); }
#evex .carousel-item .cimg {
  position: absolute;
  bottom: 40%;
  left: 15%;
}
#evex .carousel-item .cimg img { width: 25rem; }
#evex .carousel-item .cimg .pc { display: block; }
#evex .carousel-item .cimg .mobile { display: none; }
@media (max-width: 991px) {
  #evex .carousel-item .cimg { bottom: 30%; }
  #evex .carousel-item .cimg .pc { display: none; }
  #evex .carousel-item .cimg .mobile { display: block; }
}
 
 
/* ================================================
  # 브랜드 소개
================================================ */
#evex .evex-container {
  margin-top: 5rem;
  margin-bottom: 1rem;
}
.brand-wrap {
  display: flex;
  align-items: center;
  gap: 2.5rem;
  padding: 2.5rem 2.8rem;
  background: #fff;
  border-radius: var(--radius-md);
  border-left: 5px solid var(--ci-green);
  box-shadow: var(--shadow-sm);
}
@media (max-width: 767px) {
  .brand-wrap {
    flex-direction: column;
    align-items: flex-start;
    gap: 1.2rem;
    padding: 1.8rem 1.5rem;
  }
}
.brand-logo-area { flex-shrink: 0; }
.brand-logo { height: 2.8rem; width: auto; }
.brand-text-area { flex: 1; }
.brand-accent-line {
  width: 36px;
  height: 3px;
  background: var(--ci-green);
  border-radius: 2px;
  margin-bottom: 0.7rem;
}
.brand-desc {
  font-size: 1rem;
  font-weight: 500;
  color: var(--text-sub);
  margin: 0 0 1rem;
  line-height: 1.65;
}
.brand-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.brand-tag {
  display: inline-block;
  font-size: 0.78rem;
  font-weight: 700;
  color: var(--ci-green-dark);
  background: var(--ci-green-light);
  border-radius: 20px;
  padding: 3px 12px;
  letter-spacing: 0.3px;
}
 
 
/* ================================================
  # 상품 리스트 섹션
================================================ */
#evex .evex-section {
  margin: 2.5rem 0 8rem;
}
 
/* 아이템 래퍼 */
.evex-item-wrap {
  margin-bottom: 4rem;
  border-radius: var(--radius-md);
  overflow: hidden;
  background: #fff;
  box-shadow: var(--shadow-sm);
  border: 1px solid var(--gray-200);
  transition: box-shadow 0.3s ease, transform 0.3s ease;
}
.evex-item-wrap:hover {
  box-shadow: var(--shadow-md);
  transform: translateY(-3px);
}
 
/* 홀수 번째는 이미지가 왼쪽, 짝수는 오른쪽 반전 */
.evex-item-wrap:nth-child(even) .evexitem .row {
  flex-direction: row-reverse;
}
@media (max-width: 991px) {
  .evex-item-wrap:nth-child(even) .evexitem .row {
    flex-direction: row;
  }
}
 
 
/* ================================================
  # 이미지 영역
================================================ */
#evex .evexitem .pic {
  position: relative;
  overflow: hidden;
}
#evex .evexitem .pic .card-img-top {
  width: 100%;
  height: 32rem;
  object-fit: cover;
  transition: transform 0.5s ease;
  display: block;
}
#evex .evex-item-wrap:hover .evexitem .pic .card-img-top {
  transform: scale(1.04);
}
@media (max-width: 991px) {
  #evex .evexitem .pic .card-img-top { height: 22rem; }
}
@media (max-width: 575px) {
  #evex .evexitem .pic .card-img-top { height: 18rem; }
}
 
/* 호버 오버레이 */
.img-overlay {
  position: absolute;
  inset: 0;
  background: rgba(28, 28, 28, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.35s ease;
  z-index: 2;
}
#evex .evex-item-wrap:hover .img-overlay {
  opacity: 1;
}
.img-hover-label {
  color: #fff;
  font-size: 0.9rem;
  font-weight: 700;
  border: 2px solid var(--ci-green);
  padding: 9px 24px;
  border-radius: 30px;
  background: rgba(134, 205, 83, 0.15);
  letter-spacing: 0.5px;
}
 
/* 넘버링 */
.item-number {
  position: absolute;
  bottom: 0;
  left: 0;
  font-size: 5rem;
  font-weight: 900;
  line-height: 1;
  color: rgba(134, 205, 83, 0.25);
  padding: 0 0 0 1rem;
  z-index: 1;
  pointer-events: none;
  letter-spacing: -4px;
}
 
 
/* ================================================
  # 뱃지
================================================ */
#evex .badge { text-align: center; }
#evex .badge .badge1 {
  position: absolute;
  top: 0;
  left: 0;
  background: #e74c3c;
  opacity: 0.88;
  padding: 10px 15px;
  width: 150px;
  border-radius: 0 0 var(--radius-sm) 0;
  z-index: 3;
}
#evex .badge .badge1 .badge1-text {
  color: #fff;
  font-size: 1rem;
  font-weight: 700;
  padding: 0;
}
#evex .badge .badge2 {
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(255,255,255,0.92);
  padding: 10px 15px;
  width: 150px;
  border-radius: 0 0 var(--radius-sm) 0;
  z-index: 3;
}
#evex .badge .badge2 .badge2-text {
  color: var(--charcoal);
  font-size: 1rem;
  font-weight: 700;
  padding: 0;
}
 
 
/* ================================================
  # 텍스트 영역 (einfo)
================================================ */
#evex .evexitem .einfo {
  padding: 2.5rem 2.8rem;
}
@media (max-width: 991px) {
  #evex .evexitem .einfo { padding: 1.5rem 1.5rem; }
}
 
/* 출발 태그 */
.departure-tag {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.5px;
  color: var(--ci-green-dark);
  background: var(--ci-green-light);
  border-radius: 20px;
  padding: 4px 14px;
  margin-bottom: 1rem;
}
 
/* 상품명 */
#evex .evexitem .einfo .title {
  font-size: 1.65rem;
  font-weight: 700;
  color: var(--text-main);
  line-height: 1.35;
  margin-bottom: 0.8rem;
  letter-spacing: -0.3px;
}
@media (max-width: 991px) {
  #evex .evexitem .einfo .title { font-size: 1.2rem; }
}
 
/* 설명 */
#evex .evexitem .einfo .binfo {
  color: var(--gray-400);
  font-size: 0.9rem;
  line-height: 1.65;
  margin: 0 0 1.8rem;
  border-left: 3px solid var(--ci-green-light);
  padding-left: 0.8rem;
}
@media (max-width: 991px) {
  #evex .evexitem .einfo .binfo { margin: 0 0 1rem; font-size: 0.85rem; }
}
 
/* 가격 */
.price-area { margin-bottom: 2rem; }
.price-row { align-items: baseline; }
.ndayPrice { color: var(--text-main); }
.price-won {
  font-size: 1rem;
  color: var(--gray-400);
  font-weight: 400;
  margin-left: 3px;
}
.original-price { font-size: 0.95rem !important; }
.discount-rate {
  font-size: 1.1rem !important;
  font-weight: 800 !important;
  color: #e74c3c !important;
}
.final-price { color: var(--text-main) !important; }
.preparing-wrap { gap: 6px; }
.preparing-text { color: var(--gray-600) !important; }
#evex .evexitem .mbus-icon { width: 2rem !important; height: auto !important; }
 
/* 상세보기 버튼 */
#evex .evexitem .einfo .emore { margin-top: 2.5rem; }
@media (max-width: 991px) {
  #evex .evexitem .einfo .emore { margin-top: 1.5rem; }
}
.detail-btn {
  display: inline-flex;
  align-items: center;
  padding: 12px 32px;
  background: var(--ci-green);
  color: #fff;
  font-size: 0.95rem;
  font-weight: 700;
  letter-spacing: 2px;
  border-radius: var(--radius-md);
  box-shadow: 0 4px 14px rgba(134, 205, 83, 0.35);
  transition: background 0.22s ease, color 0.22s ease, transform 0.15s ease, box-shadow 0.22s ease;
}
.detail-btn:hover {
  background: var(--charcoal);
  color: var(--ci-green);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(28,28,28,0.18);
}
</style>  